import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import ProformaInvoiceForm from '../components/ProformaInvoiceForm';
import { useGetProformaInvoiceHandler } from '../dataHandlers/getProformaInvoiceHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function ProformaInvoiceDetailsPage() {
  const navigate = useNavigate();
  const { proformaInvoices: pi } = useTranslatedMessages();
  useDocumentTitle(pi?.pages?.details?.document_title ?? 'Proforma Invoice Details');
  const { document_id } = useParams();
  const { invoice, isLoading } = useGetProformaInvoiceHandler(document_id);
  const onClickingBackButton = async () => {
    return navigate('/sales/proforma-invoices');
  };

  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <ProformaInvoiceForm onSubmit={() => {}} onCancel={onClickingBackButton} initialData={invoice} readOnly={true} />
    </Stack>
  );
}
